const logging = false

export const siteAddress = (() => {
  const base = document.querySelector('base') || null,
        origin = window.location.origin || null

  let address = null

  // Default to grabbing from the base element
  // Works well with most sites.
  // Including shared domains (501 sites)

  if (base && base.href && (base.getAttribute('href') !== '')) {
    const baseHref = base.href.split('?')[0]
    
    address = baseHref
  
    if (logging) console.log('Base:', baseHref, { address })
  }
    
  // Fallback to origin
  // Only good for sites that use the domain as their root
  if (!address) {
    address = (origin) ? origin : null
  
    if (logging) console.log('Origin Fallback: ', origin, { address })
  }
  
  // Remove Trailing Slash
  // Lowercase Everything
  if (address) address = address.replace(/\/$/, "").toLowerCase()
  
  if (logging) console.log('Final Site Address: ', address, { address })
  
  return address
})()


export const isDssPreview = window.location.href.toLowerCase().includes('/dsspreview')

export default {
  siteAddress,
  isDssPreview
}